import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('deedPage/addAttendeesOverlay') || initialState;

export const selectResults = createSelector(selectState, (state) => state.get('results'));

export const selectTerm = createSelector(selectState, (state) => state.get('term'));

export const selectSearchLoading = createSelector(selectState, (state) =>
  state.get('searchLoading')
);

export const selectError = createSelector(selectState, (state) => state.get('error'));
